import { createAsyncThunk } from "@reduxjs/toolkit";
import { handleThunkRequest } from "../../lib/handleThunkRequest";
import { ApiResponse, ErrorResponse } from "src/types";
import { AdtraceEventType } from "src/types/api/analytics.types";
import { adtraceEvent } from "../../services/apiAnalytics";

//////////////////////////////////////////
export const adtraceEventThunk = createAsyncThunk<
  ApiResponse<null>, // return type
  AdtraceEventType, // argument passed to thunk
  { rejectValue: ErrorResponse }
>("analytics/adtraceEvent", async (data, thunkAPI) => {
  return await handleThunkRequest({
    thunkAPI,
    requestFn: () => adtraceEvent(data),
    method: "POST",
    redirectOn401: true,
  });
});
